var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFacebookIcon = function SvgFacebookIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44.51,
    height: 44.51,
    viewBox: "0 0 44.51 44.51",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11751.604 -9124.813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8,0A18.8,18.8,0,1,0,37.6,18.8,18.828,18.828,0,0,0,18.8,0Zm5.532,10.83a.27.27,0,0,1-.281.281H21.66a1.061,1.061,0,0,0-1.078,1.078v2.485h3.376a.264.264,0,0,1,.281.328l-.281,3.516a.3.3,0,0,1-.281.281H20.582V30.521a.27.27,0,0,1-.281.281H16.034a.27.27,0,0,1-.281-.281V18.847H13.6a.27.27,0,0,1-.281-.281V15a.27.27,0,0,1,.281-.281h2.157V11.3a4.3,4.3,0,0,1,4.313-4.313H24.1a.27.27,0,0,1,.281.281V10.83Z",
    transform: "translate(11755.604 9129.813)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebookIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook-icon.b165c73f.svg";
export { ForwardRef as ReactComponent };